// import React, { useState, useEffect } from "react";
// import FormField from "../../../components/ui/FormField";
// import { Button } from "../../../components/Button";

// const ShThreeForm = () => {
//   const [entries, setEntries] = useState(() => {
//     const saved = localStorage.getItem("sh3_register_data");
//     return saved ? JSON.parse(saved) : [{ id: Date.now() }];
//   });
//   console.log("sh3333==", entries);
//   useEffect(() => {
//     localStorage.setItem("sh3_register_data", JSON.stringify(entries));
//   }, [entries]);

//   const updateField = (id, field, value) => {
//     setEntries((prev) =>
//       prev.map((entry) =>
//         entry.id === id ? { ...entry, [field]: value } : entry,
//       ),
//     );
//   };

//   const addEntry = () => {
//     setEntries([...entries, { id: Date.now() }]);
//   };

//   const deleteEntry = (id) => {
//     if (entries.length > 1) {
//       setEntries(entries.filter((e) => e.id !== id));
//     }
//   };

//   return (
//     <div className="max-w-7xl mx-auto p-4 md:p-8 bg-slate-50 min-h-screen font-sans text-slate-800">
//       {/* Header Section from Image */}
//       <div className="bg-white border-b-4  p-8 mb-10 text-center shadow-sm rounded-t-lg">
//         <h1 className="text-2xl font-black uppercase tracking-tight">
//           Form No. SH - 3
//         </h1>
//         <h2 className="text-xl font-bold mt-1">
//           Register of Sweat Equity Shares
//         </h2>
//         <p className="text-[10px] italic text-slate-500 mt-2 max-w-3xl mx-auto">
//           [Pursuant to section 54 of the Companies Act, 2013 and rule 8(14) of
//           the Companies (Share Capital and Debentures) Rules 2014]
//         </p>
//       </div>

//       <div className="space-y-12">
//         {entries.map((entry, index) => (
//           <div
//             key={entry.id}
//             className="bg-white border border-slate-200 rounded-xl shadow-md overflow-hidden transition-all hover:shadow-lg"
//           >
//             <div className="bg-primary text-white px-6 py-3 flex justify-between items-center">
//               <span className="font-bold text-xs uppercase tracking-widest text-slate-200">
//                 Record Entry No: {index + 1}
//               </span>
//               {entries.length > 1 && (
//                 <button
//                   onClick={() => deleteEntry(entry.id)}
//                   className="text-[10px] bg-red-600 px-3 py-1 rounded hover:bg-red-700 font-bold uppercase transition"
//                 >
//                   Remove Record
//                 </button>
//               )}
//             </div>

//             <div className="p-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//               {/* Columns 1-21 mapped directly from image */}
//               {/* <FormField label="(1) S.No" value={entry.sNo} onChange={(v) => updateField(entry.id, 'sNo', v)} /> */}
//               <FormField
//                 label=" Reference to entry in register of members"
//                 value={entry.refMembers}
//                 onChange={(v) => updateField(entry.id, "refMembers", v)}
//               />
//               <FormField
//                 label=" Name of the allottee"
//                 value={entry.allotteeName}
//                 onChange={(v) => updateField(entry.id, "allotteeName", v)}
//               />

//               <FormField
//                 label=" Status of the allottee – whether director or employee"
//                 value={entry.allotteeStatus}
//                 onChange={(v) => updateField(entry.id, "allotteeStatus", v)}
//               />
//               <FormField
//                 label=" Date of passing of Board resolution"
//                 type="date"
//                 value={entry.boardResDate}
//                 onChange={(v) => updateField(entry.id, "boardResDate", v)}
//               />
//               <FormField
//                 label=" Date of the special resolution authorizing the issue of sweat equity shares"
//                 type="date"
//                 value={entry.specResDate}
//                 onChange={(v) => updateField(entry.id, "specResDate", v)}
//               />

//               <FormField
//                 label="Date of issue of sweat equity shares"
//                 type="date"
//                 value={entry.issueDate}
//                 onChange={(v) => updateField(entry.id, "issueDate", v)}
//               />
//               <FormField
//                 label="Number of sweat equity shares issued"
//                 type="number"
//                 value={entry.numShares}
//                 onChange={(v) => updateField(entry.id, "numShares", v)}
//               />
//               <FormField
//                 label="Certificate No. / Folio No."
//                 value={entry.certFolioNo}
//                 onChange={(v) => updateField(entry.id, "certFolioNo", v)}
//               />

//               <FormField
//                 label=" Face value of the share"
//                 value={entry.faceValue}
//                 onChange={(v) => updateField(entry.id, "faceValue", v)}
//               />
//               <FormField
//                 label=" Price at which the shares are issued"
//                 value={entry.issuePrice}
//                 onChange={(v) => updateField(entry.id, "issuePrice", v)}
//               />
//               <FormField
//                 label="Amount to be treated as paid up"
//                 value={entry.paidUpAmount}
//                 onChange={(v) => updateField(entry.id, "paidUpAmount", v)}
//               />

//               {/* Section for Consideration Paid (Columns 13-14) */}
//               <div className="p-1 border-2 border-slate-100 rounded-lg bg-slate-50/50 lg:col-span-2">
//                 <label className="block text-[10px] font-black text-slate-400 uppercase mb-1">
//                   Total consideration paid, if any, by the employee / director
//                 </label>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                   <FormField
//                     label=" Consideration received in cash"
//                     value={entry.cashConsideration}
//                     onChange={(v) =>
//                       updateField(entry.id, "cashConsideration", v)
//                     }
//                   />
//                   <FormField
//                     label=" Particulars of consideration other than cash"
//                     type="description"
//                     value={entry.nonCashConsideration}
//                     onChange={(v) =>
//                       updateField(entry.id, "nonCashConsideration", v)
//                     }
//                   />
//                 </div>
//               </div>

//               <FormField
//                 label=" Lock in period"
//                 value={entry.lockInPeriod}
//                 onChange={(v) => updateField(entry.id, "lockInPeriod", v)}
//               />
//               <FormField
//                 label=" Date of expiry of lock-in-period"
//                 type="date"
//                 value={entry.lockInExpiry}
//                 onChange={(v) => updateField(entry.id, "lockInExpiry", v)}
//               />
//               <FormField
//                 label=" Remarks, if any"
//                 type="description"
//                 value={entry.remarks}
//                 onChange={(v) => updateField(entry.id, "remarks", v)}
//               />

//               <FormField
//                 label=" Date of Joining"
//                 type="date"
//                 value={entry.joiningDate}
//                 onChange={(v) => updateField(entry.id, "joiningDate", v)}
//               />
//               <FormField
//                 label=" Fair value obtained by Valuer"
//                 value={entry.fairValue}
//                 onChange={(v) => updateField(entry.id, "fairValue", v)}
//               />
//               <FormField
//                 label=" Basis of Valuation"
//                 type="description"
//                 value={entry.valuationBasis}
//                 onChange={(v) => updateField(entry.id, "valuationBasis", v)}
//               />

//               <FormField
//                 label="Name of Valuer"
//                 value={entry.valuerName}
//                 onChange={(v) => updateField(entry.id, "valuerName", v)}
//               />
//             </div>
//           </div>
//         ))}
//       </div>

//       <div className="flex w-full justify-between items-center">
//         <Button
//           label="'Add New SH-3 Register Entry'"
//         //   onClick={addDirector}
//           className="mt-2"
//         />

//         <Button
//           label="Save Register Data"
//         //   onClick={handleSave}
//           className="mt-2"
//         />
//       </div>
//     </div>
//   );
// };

// export default ShThreeForm;
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import FormField from "../../../components/ui/FormField";
import { Button } from "../../../components/Button";
import { sh3RegisterApi } from "../../../api/ShThreeApi";
import { ArrowLeft, Trash2 } from "lucide-react";

// Map frontend entry fields → backend request DTO
const mapEntryToRequest = (entry) => ({
  referenceToRegisterOfMembers: entry.refMembers || "",
  nameOfAllottee: entry.allotteeName || "",
  statusOfAllottee: entry.allotteeStatus || "",
  boardResolutionDate: entry.boardResDate || null,
  specialResolutionDate: entry.specResDate || null,
  issueDate: entry.issueDate || null,
  numberOfSharesIssued: entry.numShares ? parseInt(entry.numShares, 10) : null,
  faceValuePerShare: entry.faceValue ? parseFloat(entry.faceValue) : null,
  issuePricePerShare: entry.issuePrice ? parseFloat(entry.issuePrice) : null,
  amountTreatedAsPaidUp: entry.paidUpAmount ? parseFloat(entry.paidUpAmount) : null,
  certificateOrFolioNo: entry.certFolioNo || null,
  considerationReceivedInCash: entry.cashConsideration ? parseFloat(entry.cashConsideration) : null,
  considerationOtherThanCash: entry.nonCashConsideration || null,
  lockInPeriodInMonths: entry.lockInPeriod ? parseInt(entry.lockInPeriod, 10) : null,
  lockInExpiryDate: entry.lockInExpiry || null,
  remarks: entry.remarks || null,
  dateOfJoining: entry.joiningDate || null,
  fairValueObtainedByValuer: entry.fairValue ? parseFloat(entry.fairValue) : null,
  basisOfValuation: entry.valuationBasis || "",
  nameOfValuer: entry.valuerName || "",
});

const ShThreeForm = () => {
  // ✅ Token from Redux (same as MgtForm)
  const token = useSelector((state) => state.auth.access_token);

  // ✅ Companies from Redux (same as MgtForm)
  const companies = useSelector((state) => state.account.accountDetails);

  const [accountId, setAccountId] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // { type: 'success' | 'error', message: string }

  const [entries, setEntries] = useState(() => {
    const saved = localStorage.getItem("sh3_register_data");
    return saved ? JSON.parse(saved) : [{ id: Date.now() }];
  });

  useEffect(() => {
    localStorage.setItem("sh3_register_data", JSON.stringify(entries));
  }, [entries]);

  // ✅ Company selection handler (same pattern as MgtForm)
  const handleCompanyChange = (e) => {
    const selectedValue = e.target.value;

    if (selectedValue === "") {
      setAccountId("");
      setCompanyName("");
      return;
    }

    const selectedCompany = companies.find(
      (company) => String(company.id) === String(selectedValue)
    );

    if (selectedCompany) {
      setAccountId(selectedCompany.id);
      setCompanyName(selectedCompany.accountName || "");
    } else {
      console.error("Company not found for value:", selectedValue);
    }
  };

  const updateField = (id, field, value) => {
    setEntries((prev) =>
      prev.map((entry) =>
        entry.id === id ? { ...entry, [field]: value } : entry
      )
    );
  };

  const addEntry = () => {
    setEntries([...entries, { id: Date.now() }]);
  };

  const deleteEntry = (id) => {
    if (entries.length > 1) {
      setEntries(entries.filter((e) => e.id !== id));
    }
  };

  const handleSave = async () => {
    if (!accountId) {
      setSubmitStatus({ type: "error", message: "Please select a company before saving." });
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // ✅ Send one request per entry (backend accepts single object, not array)
      for (const entry of entries) {
        const payload = mapEntryToRequest(entry);
        await sh3RegisterApi.submitSh3Form(payload, accountId, token);
      }

      setSubmitStatus({ type: "success", message: "SH-3 Register data saved successfully!" });
      localStorage.removeItem("sh3_register_data");
    } catch (error) {
      setSubmitStatus({
        type: "error",
        message: error.message || "Failed to save SH-3 register data. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      {/* Header */}
      <div className="bg-white border-b-4 p-3 mb-2 text-center shadow rounded-xl relative">
        <button
          onClick={() => window.history.back()}
          className="absolute top-3 left-4 flex items-center gap-2 text-gray-600 hover:text-gray-900"
        >
          <ArrowLeft size={18} />
          <span className="text-sm font-medium">Back</span>
        </button>
        <h1 className="text-2xl font-black uppercase tracking-tight">
          Form No. SH - 3
        </h1>
        <h2 className="text-xl font-bold mt-1">
          Register of Sweat Equity Shares
        </h2>
        <p className="text-[10px] italic text-slate-500 mt-2 max-w-3xl mx-auto">
          [Pursuant to section 54 of the Companies Act, 2013 and rule 8(14) of
          the Companies (Share Capital and Debentures) Rules 2014]
        </p>
      </div>

      {/* ✅ Company Selection (same as MgtForm) */}
      <div className="bg-white rounded-xl shadow border border-slate-200 p-3 mb-2">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Name of the company *
          </label>
          <select
            value={accountId}
            onChange={handleCompanyChange}
            disabled={loading}
            className="w-50 px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select a company</option>
            {companies.map((company) => (
              <option key={company.id} value={company.id}>
                {company.accountName || `Company ${company.id}`}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Status Message */}
      {submitStatus && (
        <div
          className={`mb-6 px-4 py-3 rounded-lg text-sm font-medium border ${submitStatus.type === "success"
              ? "bg-green-50 text-green-800 border-green-200"
              : "bg-red-50 text-red-800 border-red-200"
            }`}
        >
          {submitStatus.message}
        </div>
      )}

      <div className="space-y-2">
        {entries.map((entry, index) => (
          <div
            key={entry.id}
            className="bg-white border border-slate-200 rounded-xl shadow overflow-hidden"
          >
            <div className="bg-primary text-white px-3 py-2 flex justify-between items-center">
              <span className="font-semibold text-sm uppercase tracking-widest text-slate-200">
                Record Entry No: {index + 1}
              </span>
              {entries.length > 1 && (
                <button
                  onClick={() => deleteEntry(entry.id)}
                  className="text-xs text-red-600 px-2 py-1 rounded-md flex flex-row items-center gap-1 bg-white font-bold uppercase">
                  <Trash2 size={16} /> Record
                </button>
              )}
            </div>

            <div className="p-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
              <FormField
                label="Reference to entry in register of members"
                value={entry.refMembers}
                onChange={(v) => updateField(entry.id, "refMembers", v)}
              />
              <FormField
                label="Name of the allottee"
                value={entry.allotteeName}
                onChange={(v) => updateField(entry.id, "allotteeName", v)}
              />
              <FormField
                label="Status of the allottee – whether director or employee"
                value={entry.allotteeStatus}
                onChange={(v) => updateField(entry.id, "allotteeStatus", v)}
              />
              <FormField
                label="Date of passing of Board resolution"
                type="date"
                value={entry.boardResDate}
                onChange={(v) => updateField(entry.id, "boardResDate", v)}
              />
              <FormField
                label="Date of the special resolution authorizing the issue of sweat equity shares"
                type="date"
                value={entry.specResDate}
                onChange={(v) => updateField(entry.id, "specResDate", v)}
              />
              <FormField
                label="Date of issue of sweat equity shares"
                type="date"
                value={entry.issueDate}
                onChange={(v) => updateField(entry.id, "issueDate", v)}
              />
              <FormField
              type="number"
                label="Number of sweat equity shares issued"
              
                value={entry.numShares}
                onChange={(v) => updateField(entry.id, "numShares", v)}
              />
              <FormField
              type="number"
                label="Certificate No. / Folio No."
                value={entry.certFolioNo}
                onChange={(v) => updateField(entry.id, "certFolioNo", v)}
              />
              <FormField
              type="number"
                label="Face value of the share"
                value={entry.faceValue}
                onChange={(v) => updateField(entry.id, "faceValue", v)}
              />
              <FormField
              type="number"
                label="Price at which the shares are issued"
                value={entry.issuePrice}
                onChange={(v) => updateField(entry.id, "issuePrice", v)}
              />
              <FormField
              type="number"
                label="Amount to be treated as paid up"
                value={entry.paidUpAmount}
                onChange={(v) => updateField(entry.id, "paidUpAmount", v)}
              />

              {/* Consideration Section */}
              <div className="p-1 border-2 border-slate-100 rounded-lg bg-slate-50/50 lg:col-span-2">
                <label className="block text-[10px] font-black text-slate-400 uppercase mb-1">
                  Total consideration paid, if any, by the employee / director
                </label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <FormField
                  type="number"
                    label="Consideration received in cash"
                    value={entry.cashConsideration}
                    onChange={(v) => updateField(entry.id, "cashConsideration", v)}
                  />
                  <FormField
                    label="Particulars of consideration other than cash"
                    type="description"
                    value={entry.nonCashConsideration}
                    onChange={(v) => updateField(entry.id, "nonCashConsideration", v)}
                  />
                </div>
              </div>

              <FormField
              type="number"
                label="Lock in period in months"
                value={entry.lockInPeriod}
                onChange={(v) => updateField(entry.id, "lockInPeriod", v)}
              />
              <FormField
                label="Date of expiry of lock-in-period"
                type="date"
                value={entry.lockInExpiry}
                onChange={(v) => updateField(entry.id, "lockInExpiry", v)}
              />
              <FormField
                label="Remarks, if any"
                type="description"
                value={entry.remarks}
                onChange={(v) => updateField(entry.id, "remarks", v)}
              />
              <FormField
                label="Date of Joining"
                type="date"
                value={entry.joiningDate}
                onChange={(v) => updateField(entry.id, "joiningDate", v)}
              />
              <FormField
              type="number"
                label="Fair value obtained by Valuer"
                value={entry.fairValue}
                onChange={(v) => updateField(entry.id, "fairValue", v)}
              />
              <FormField
                label="Basis of Valuation"
                type="description"
                value={entry.valuationBasis}
                onChange={(v) => updateField(entry.id, "valuationBasis", v)}
              />
              <FormField
                label="Name of Valuer"
                value={entry.valuerName}
                onChange={(v) => updateField(entry.id, "valuerName", v)}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="flex w-full justify-between items-center mt-1">
        <Button
          label="Add New SH-3 Register Entry"
          onClick={addEntry}
          className="mt-2 text-xs"
        />
        <Button
          label={isSubmitting ? "Saving..." : "Save Register Data"}
          onClick={handleSave}
          disabled={isSubmitting}
          className="mt-2 text-xs"
        />
      </div>
    </div>
  );
};

export default ShThreeForm;